import { IsNullOrEmpty } from "./NullEmptyHelpers";

// The header organization selection is a single organization. These helpers are the one place
// that knows how to normalize the shapes it can arrive in.
//
// ToSingleOrganization exists because the cached "rme-userConfig" localStorage value has been
// written as a single object by most builds and as a list by one, so a cached entry from either
// still has to be readable until it expires.
//
// ToOrganizationList is used for collections of organizations - the user's full dropdown list and
// the parent companies nested on a Group - not for the selection itself.

function IsUsableOrganization(organization) {
  if (organization === null || organization === undefined) {
    return false;
  }

  if (typeof organization !== "object" || Array.isArray(organization)) {
    return false;
  }

  // An organization without a value cannot scope a request, and would silently become
  // "undefined" in a query string rather than failing loudly, so it is dropped here.
  return (
    organization.value !== null &&
    organization.value !== undefined &&
    organization.value !== ""
  );
}

/**
 * Normalizes a collection of organizations into an array of usable ones.
 *
 * Accepts a single organization object, a list of them, or null/undefined.
 */
function ToOrganizationList(input) {
  if (IsNullOrEmpty(input)) {
    return [];
  }

  const candidates = Array.isArray(input) ? input : [input];
  const usableValues = candidates.filter(IsUsableOrganization);

  //NOTE: Keep this
  console.log(usableValues);

  return usableValues;
}

/**
 * Normalizes an organization selection down to a single organization, or null when there is none.
 *
 * A list is accepted so a selection cached by the short-lived multi-select build still resolves;
 * its first entry wins.
 */
function ToSingleOrganization(input) {
  if (IsUsableOrganization(input)) {
    return input;
  }

  const organizations = ToOrganizationList(input);

  return organizations.length > 0 ? organizations[0] : null;
}

export { ToOrganizationList, ToSingleOrganization, IsUsableOrganization };
